module.exports = __webpack_public_path__ + "media/images/players/PEREIRA_MITO-591c6133941cc87310012ea21d26bf4c.png";